module.exports = __webpack_public_path__ + "img/responsive crc-04.9ea1d780.jpg";